module.exports = __webpack_public_path__ + "static/media/sample_bulk_trucks.2d13b64b.csv";